const checkRoutePermissions = (authData: any, route: any) => {

  //  PREMIER ADMIN
  if (authData.isSuperUser) {
    return true; // PREMIER ADMINS can see everything except Account (They See admin Panel instead)
  }

  //   Portal User
  if (authData.isPortalUser) {
    if ([''].includes(route.state)) return false; // Routes That are Hidden
    if ([''].includes(route.state)) { // Routes That are Greyed Out as inaccessible for current Tier
      return 'premium';
    }
    return true;
  }
  //   return true; // PREMIER ADMINS can see everything except Account (They See admin Panel instead)
  // }

  //   App User
  if (authData.isPortalUser) {
    if ([''].includes(route.state)) return false; // Routes That are Hidden
    if ([''].includes(route.state)) { // Routes That are Greyed Out as inaccessible for current Tier
      return 'premium';
    }
    return true;
  }

  return false;
};


export default checkRoutePermissions;